import {Accordion} from '@/components-v2/molecules'
import {useFeatureFlagLanguages} from '@/hooks/useFeatureFlagLanguages'
import {PromotionReviewAdditionalInformation} from './PromotionReviewAdditionalInformation'
import {PromotionReviewAttributes} from './PromotionReviewAttributes'
import {PromotionReviewDisplay} from './PromotionReviewDisplay'
import {PromotionReviewSetup} from './PromotionReviewSetup'

const mockLanguages = [
  {code: 'en', language: 'English'},
  {code: 'es-MX', language: 'Spanish (Mexico)'},
]

/**
 * @param {{
 *  data: import('@/types/promotion').Promotion,
 *  isDetailView?: boolean,
 *  setCurrentStep?: (step: import('@/types/promotion').PromotionStep) => void,
 *  showEditForAll?: boolean,
 * }} props
 */
export const PromotionReview = ({data, isDetailView = false, setCurrentStep = () => {}, showEditForAll = true}) => {
  const languagesFromHook = useFeatureFlagLanguages()
  const languages = languagesFromHook?.length > 0 ? languagesFromHook : mockLanguages

  const showEdit = showEditForAll || !isDetailView
  const promoExpired = data?.status?.toUpperCase() === 'EXPIRED'
  const canEdit = showEdit && !promoExpired

  return (
    <div className="w-full overflow-hidden">
      <Accordion size="large" presentation="box-shadow" className="font-body w-full">
        <div className="flex w-full flex-col gap-4">
          <PromotionReviewSetup
            promotionReviewData={data}
            showEdit={canEdit}
            setCurrentStep={setCurrentStep}
          />
          <PromotionReviewDisplay
            promotionReviewData={data}
            showEdit={canEdit}
            setCurrentStep={setCurrentStep}
            languages={languages}
          />
          <PromotionReviewAttributes
            promotionReviewData={data}
            showEdit={canEdit}
            setCurrentStep={setCurrentStep}
          />
          <PromotionReviewAdditionalInformation promotionReviewData={data} />
        </div>
      </Accordion>
    </div>
  )
}
